import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";

interface GridRowProps {
  children: ReactNode | ReactNode[];
  displayFlex?: boolean;
  mobileOrder?: undefined | -1;
  noWrapForTablet?: boolean;
  overflowHidden?: boolean;
}

const GridPresetOneHalf = ({
  children,
  displayFlex,
  mobileOrder,
  noWrapForTablet,
  overflowHidden,
}: GridRowProps) => (
  <GridCell
    spanColsDesktop={6}
    spanColsTablet={noWrapForTablet ? 3 : 6}
    spanColsMobile={6}
    displayFlex={displayFlex}
    mobileOrder={mobileOrder}
    overflowHidden={overflowHidden}
  >
    {children}
  </GridCell>
);

export default GridPresetOneHalf;
